import { getVisitCountApi } from "@/utils/api";
import { handleRequestFailure } from "@/utils/http";
import { loginLocation } from "@/utils/authSession";
import store from "@/store";
export default {
  isAuthenticated() {
    const token = store.state.token || localStorage.getItem("token");
    return !!token && token !== "null" && token !== "undefined";
  },

  redirectIfNotAuthenticated(to, from, next) {
    getVisitCountApi().catch(handleRequestFailure);
    to.path !== "/login" &&
      to.matched.some((record) => record.meta.requireAuth) && !this.isAuthenticated()
      ? next(loginLocation(to.fullPath))
      : next();

  },
};
